module.exports = __webpack_public_path__ + "static/media/no.4b7d6a30.png";